import React, { useEffect, useState } from 'react';
import {
  getFirestore,
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
  deleteDoc,
  doc,
  updateDoc,
  Timestamp
} from "firebase/firestore";

import { auth } from './firebaseConfig';
import { onAuthStateChanged } from "firebase/auth";

const db = getFirestore();

function RemindersList() {
  const [reminders, setReminders] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState('');
  const [editDate, setEditDate] = useState('');

  useEffect(() => {
    let unsubscribeReminders = () => {};
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      unsubscribeReminders();
      setReminders([]);
      if (user) {
        const q = query(
          collection(db, "reminders"),
          where("userId", "==", user.uid),
          orderBy("date", "asc")
        );
        unsubscribeReminders = onSnapshot(q, (snapshot) => {
          const data = snapshot.docs.map(d => ({
            id: d.id,
            ...d.data(),
          }));
          setReminders(data);
        });
      }
    });
    return () => {
      unsubscribeReminders();
      unsubscribeAuth();
    };
  }, []);

  // Converts "YYYY-MM-DD" into a local midnight Timestamp (prevents date shift)
const toLocalMidnightTimestamp = (yyyyMmDd) => {
  const [y, m, d] = yyyyMmDd.split('-').map(Number);
  const local = new Date(y, m - 1, d, 0, 0, 0, 0);
  return Timestamp.fromDate(local);
};


  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, "reminders", id));
    } catch (error) {
      alert("Error deleting reminder: " + error.message);
    }
  };

  const handleEdit = (reminder) => {
    setEditingId(reminder.id);
    setEditText(reminder.text);
    const dateVal = reminder.date?.toDate ? reminder.date.toDate() : new Date();
    setEditDate(dateVal.toISOString().split('T')[0]);
  };

  const handleSave = async (id) => {
    try {
      const ref = doc(db, "reminders", id);
      await updateDoc(ref, {
  text: editText,
  date: toLocalMidnightTimestamp(editDate),
});

      setEditingId(null);
    } catch (error) {
      alert("Error updating reminder: " + error.message);
    }
  };

  return (
    <div style={{ marginTop: '20px' }}>
      <h2>Your Reminders</h2>
      {reminders.length === 0 && <p>No reminders found.</p>}
      <ul style={{ listStyle: 'none', padding: 0 }}>
        {reminders.map((reminder) => {
          const isEditing = editingId === reminder.id;
          const dateVal = reminder.date?.toDate?.() || new Date();
          const dateText = dateVal.toLocaleDateString();

          return (
            <li
              key={reminder.id}
              style={{
                marginBottom: '10px',
                padding: '10px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              {isEditing ? (
                <div style={{ flex: 1 }}>
                  <input
                    type="text"
                    value={editText}
                    onChange={(e) => setEditText(e.target.value)}
                    style={{ marginBottom: '5px', padding: '5px', width: '100%' }}
                  />
                  <input
                    type="date"
                    value={editDate}
                    onChange={(e) => setEditDate(e.target.value)}
                    style={{ marginBottom: '5px', padding: '5px', width: '100%' }}
                  />
                </div>
              ) : (
                <div style={{ flex: 1 }}>
                  <strong>{reminder.text}</strong>
                  <div style={{ fontSize: '12px', color: '#666' }}>{dateText}</div>
                </div>
              )}

              <div>
                {isEditing ? (
                  <>
                    <button
                      onClick={() => handleSave(reminder.id)}
                      style={{
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        marginRight: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      Save
                    </button>
                    <button
                      onClick={() => setEditingId(null)}
                      style={{
                        backgroundColor: '#6c757d',
                        color: 'white',
                        border: 'none',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Cancel
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={() => handleEdit(reminder)}
                      style={{
                        backgroundColor: '#ffc107',
                        color: 'black',
                        border: 'none',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        marginRight: '5px',
                        cursor: 'pointer',
                      }}
                    >
                      Edit
                    </button>
                    <button
                      onClick={() => handleDelete(reminder.id)}
                      style={{
                        backgroundColor: '#dc3545',
                        color: 'white',
                        border: 'none',
                        padding: '6px 10px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Delete
                    </button>
                  </>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default RemindersList;
